import type { SaleFormValues } from "./sale-schema";
import type { Sale } from "@artisancode/api-types";

export function todayIso(): string {
  return new Date().toISOString().slice(0, 10);
}

export function calculateGrandTotal(
  lines: { qty?: number; sellingPrice?: number }[] | undefined,
): number {
  return (lines ?? []).reduce(
    (sum, l) => sum + Number(l.qty || 0) * Number(l.sellingPrice || 0),
    0,
  );
}

export function saleToFormValues(sale: Sale): SaleFormValues {
  return {
    date: sale.date,
    channel: sale.channel,
    customerName: sale.customerName,
    transactionCode: sale.transactionCode ?? "",
    lines: sale.items.map((i) => ({
      productId: i.productId,
      qty: i.qty,
      sellingPrice: i.sellingPrice,
    })),
    paymentStatus: sale.paymentStatus,
    paymentMethod: sale.paymentMethod,
    notes: sale.notes ?? "",
  };
}
